module.exports = __webpack_public_path__ + "img/exhibition-img1.892bdcb3.png";